import {
  RECEIVE_FIND_CHANNEL,
  RECEIVE_INACTIVE_CHANNELS,
  RECEIVE_LOCATION_SEARCH,
  REQUEST_FIND_CHANNEL,
  REQUEST_INACTIVE_CHANNELS,
  REQUEST_LOCATION_SEARCH,
} from "../actions";
import { RECEIVE_CHANNELS } from "../actions/channel";
import { RECEIVE_USER } from "../actions/user";

const DEFAULT_STATE = {
  byId: {},
  locationSearch: {
    pending: false,
    result: [],
  },
  stationSearch: {
    pending: false,
    result: [],
  },
  inactiveChannels: { pages: {} },
};

const addChannels = (state, channels) => {
  if (channels) {
    channels.forEach((c) => {
      // Fetching an individual channel has more fields than when fetching
      // channels in bulk. We don't want to overwrite any existing extra
      // fields.
      const oldChannel = state.byId[c.id];
      state.byId[c.id] = { ...oldChannel, ...c };
    });
  }
};

const channelReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case RECEIVE_CHANNELS: {
      const newState = { ...state, byId: { ...state.byId } };
      addChannels(newState, action.data);
      return newState;
    }

    case RECEIVE_USER: {
      const newState = { ...state, byId: { ...state.byId } };
      addChannels(newState, action.data.favourites);
      return newState;
    }

    case REQUEST_LOCATION_SEARCH:
      return {
        ...state,
        locationSearch: {
          pending: true,
          result: [],
        },
        stationSearch: {
          pending: false,
          result: [],
        },
      };

    case RECEIVE_LOCATION_SEARCH:
      return {
        ...state,
        locationSearch: {
          pending: false,
          result: action.data,
        },
      };

    case REQUEST_FIND_CHANNEL:
      return {
        ...state,
        stationSearch: {
          pending: true,
          result: [],
        },
      };

    case RECEIVE_FIND_CHANNEL:
      return {
        ...state,
        stationSearch: {
          pending: false,
          result: action.data,
        },
      };

    case RECEIVE_INACTIVE_CHANNELS:
      return {
        ...state,
        inactiveChannels: {
          pages: {
            ...state.inactiveChannels.pages,
            [action.data.page]: {
              channels: action.data.channels,
              pending: false,
            },
          },
        },
      };

    case REQUEST_INACTIVE_CHANNELS:
      return {
        ...state,
        inactiveChannels: {
          pages: {
            ...state.inactiveChannels.pages,
            [action.data.page]: {
              channels: [],
              pending: true,
            },
          },
        },
      };

    default:
      return state;
  }
};

export default channelReducer;
